

import { Link } from "react-router-dom"
import SliderVol from "./SliderVol"
import { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { MdUmbrella } from "react-icons/md";





export default function LimitOrder({customCoin,witchItem,coinBy,selectedCoinPrice,isAuth,teterPriceBuy,selected,coinsChoose,KARMOZD=0,quoteCoinIncrement,baseCoinIncrement,teterPriceSell,userBalance,setUserBalance,processing,setProcessing,isNotLoadCustPrice,coinBalance,setCoinBalance,findBalance}){

    const [amount,setamount] = useState(0)
    const [priceAmount,setPriceAmount] = useState(0)
    const [TargetPrice,setTargetPrice] = useState(0)
    const [buttonClicked,setButtonClicked] = useState(false)
    const [disabled,setDisable] = useState(false)
    const [sellAmountInput,setSellAmountInput] = useState(0)


    
    





    function handelSubmit(side) {
       setDisable(true)
 
 
 
 
         axios.post('https://api.sinatether.com/Auth/create_limit_order/',{
             'symbolOne':coinsChoose['value'],
             'symbolTwo':coinBy['value'],
             'target_price': TargetPrice,
             'side': side,
             'size': amount,
             'priceWithKarmozd': priceAmount,
             'price':priceAmount-(priceAmount*KARMOZD),
             'baseIncrement':baseCoinIncrement,
             'queIncrement' : quoteCoinIncrement
 
 
 
         },{
             withCredentials:true
         }).then((res)=>{
             if (res.status == 200)
             {
                 var inputs = document.querySelectorAll('input')
                 if (res.data['status'] == 200)
                 {
                 
                     const audio = new Audio('coin.mp3');
                     audio.play();
                     toast.dismiss()
                     toast.success(res.data['message'])
                     
                     setButtonClicked(false)
                     setDisable(false)
                     inputs.forEach(input =>  input.value = '');
                     try{
                     if (witchItem == 'buy'){
                         findBalance(coinBy['value'])
                     }else{
                         findBalance(coinsChoose['value'])
                     }
                    }catch{

                    }
                 }
                 else {
                     toast.dismiss()
                     toast.error(res.data['message'])
 
                   
                     setButtonClicked(false)
                     setDisable(false)
                     inputs.forEach(input =>  input.value = '');
 
                 }
 
 
             }
 
         }).catch((error)=>{
             if (error){
                 if (error.response.status === 400){
                     toast.dismiss()
                     toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                 }else{
                 toast.dismiss()
                 toast.error('فرایند به طور کامل انجام نشد مجددا امتحان نمایید')
                 setButtonClicked(false)

                 setDisable(false)
             
                 var inputs = document.querySelectorAll('input')
                 inputs.forEach(input =>  input.value = '');
                 }
 
 
             }
         })
 
 
    }



    
    function handelSubmitBuy(event) {
        
        setButtonClicked(true)
        //priceAmount / teterPriceBuy < 12  ||
        

        if (  priceAmount == 0 || amount == 0){
            toast.dismiss()
            toast.error("حداقل سفارش خرید 12 تتر است")
            setButtonClicked(false)
            var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
            setamount(0)
            setPriceAmount(0)

        }else if((coinBy['value'] == 'USDT' || coinBy['value'] == 'IR') && priceAmount / teterPriceBuy < 12 ){
            toast.dismiss()
            toast.error("حداقل سفارش خرید 12 تتر است")
            setButtonClicked(false)
            var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
            setamount(0)
            setPriceAmount(0)
        }
        
        else if (coinBalance['balance'] == 0){
            toast.dismiss()
            toast.error("عدم داشتن موجودی")
            setButtonClicked(false)
            var inputs = document.querySelectorAll('input')
            inputs.forEach(input =>  input.value = '');
            setamount(0)
            setPriceAmount(0)
        }else {

                    handelSubmit('buy')
        }








    }


    useEffect(()=>{


        setamount(0)
        setPriceAmount(0)
    },[witchItem])



    
    function handelSubmitSell() {
   
        setButtonClicked(true)

    if ( priceAmount == 0 || amount == 0 ){
        toast.dismiss()
        toast.error("حداقل سفارش فروش 5 تتر است")
            setButtonClicked(false)

}else if((coinBy['value'] == 'USDT' || coinBy['value'] == 'IR') && priceAmount / teterPriceSell <= 0 ){
    toast.dismiss()
    toast.error("مقادیر وارد شده صحیح نمیباشد")
    setButtonClicked(false)
    var inputs = document.querySelectorAll('input')
    inputs.forEach(input =>  input.value = '');
    setamount(0)
    setPriceAmount(0)
}
else {

      handelSubmit('sell')


}
}

    





    

    function handleChooseBalanceClick(event,val){
        console.log(val)


        if (witchItem == 'buy') {
            let p = Number(coinBalance['balance'])
            p = toFixedTrunc(p,quoteCoinIncrement)

            var coin_balance =  coinBalance['balance']
            coin_balance = (coin_balance * val)/100

            coin_balance = coin_balance ? coin_balance : 0


            let z
            if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
            {
                console.log(TargetPrice)
                if (TargetPrice > 0){

                var a ;
                z = coin_balance
                let b =  z / (TargetPrice)
                a = parseInt(b)
                let  r = (b-a)*(TargetPrice)
                z = z - r
                console.log(a)
                setPriceAmount(z)
                setamount(a)
                document.getElementById("limit_amount").value = coinBalance['balance'] && new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(isNaN(a)? 0 : a)
                
            }





            }else {

                
            if (TargetPrice > 0){
                z = coin_balance - coin_balance*KARMOZD
                var pp = z/TargetPrice
                document.getElementById("limit_amount").value = coin_balance && new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(pp)
           
                setPriceAmount(z)
                setamount(pp)
           
            }
                   



            }






        }
        else {
            var coin_balance =  coinBalance['balance']
            coin_balance = (coin_balance * val)/100
            let p = Number(coin_balance)
            var result;

            if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
            {
                let pInt
                if(p>=1)
                {
                    pInt =  parseInt(p)

                }else{
                    pInt = 0
                }

                 

                setamount(pInt)
                 result = ((pInt * (TargetPrice)))
                setPriceAmount(pInt * (TargetPrice))
                 setSellAmountInput(p && new Intl.NumberFormat("fa", {maximumFractionDigits: baseCoinIncrement}).format(p))




            }else{
                p = toFixedTrunc(p,baseCoinIncrement)
                console.log(p)
                setamount(p)
                result = ((coin_balance * (TargetPrice))*(1-KARMOZD))
                setPriceAmount(coin_balance * (TargetPrice ))
                console.log(result)
               setSellAmountInput(p && new Intl.NumberFormat("fa", {maximumFractionDigits: baseCoinIncrement}).format(p))




            }














            if (p == 0){
                            document.getElementById("price_limit_amount-sell").value = new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(0)
                            return

            }



            if (result < 0)
            {
                document.getElementById("price_limit_amount-sell").value = new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(0)
                return
            }



            document.getElementById("price_limit_amount-sell").value = result && new Intl.NumberFormat("fa", {maximumFractionDigits: quoteCoinIncrement}).format(result)


        }





    }











    function toFixed(x) {
        if (Math.abs(x) < 1.0) {
          let e = parseInt(x.toString().split('e-')[1]);
          if (e) {
              x *= Math.pow(10,e-1);
              x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
          }
        } else {
          let e = parseInt(x.toString().split('+')[1]);
          if (e > 20) {
              e -= 20;
              x /= Math.pow(10,e);
              x += (new Array(e+1)).join('0');
          }
        }
        return x;
      }
    function toFixedTrunc(x, n) {
        x = toFixed(x) 
  
        // From here on the code is the same than the original answer
        const v = (typeof x === 'string' ? x : x.toString()).split('.');
        if (n <= 0) return v[0];
        let f = v[1] || '';
        if (f.length > n) return `${v[0]}.${f.substr(0,n)}`;
        while (f.length < n) f += '0';
        return parseFloat(`${v[0]}.${f}`)
      }


    function ex_normalNum(num,name) {
        num = num.replace(/,\s?/g, "");


        

        if (witchItem == 'buy') {

            if (name == 'limit_amount') {
                if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                {
                    num = parseInt(num)
                    let poin = (num * TargetPrice)
                    

                }else{
                    let ppoin = (num * TargetPrice)*(1+KARMOZD)

                    setPriceAmount(ppoin)

                }

                setPriceAmount(num * (TargetPrice))
                setamount(num);
            } else {
                var a;
                if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                {
                    
                    setTargetPrice(num)

                    let b = amount * num
                    b = parseInt(b)

                    setPriceAmount(b)







                }else {
                    setTargetPrice(num)
                    let ppcoi = num * amount

                    setPriceAmount(ppcoi)

                }
                 


            }


        }else if(witchItem == 'sell')
        {

            if (name == 'limit_amount_sell') {
                setamount(num);

                if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                {
                    num =  parseInt(num)
                    num = isNaN(num)? 0 : num
                    let casell = (num * TargetPrice)

                    setPriceAmount(casell)






                }else{
                    let csssell = (num * TargetPrice) - KARMOZD*(num * TargetPrice)
                    setPriceAmount(csssell)

                    


                }

            } else {
                var a;
                setTargetPrice(num)
                if (coinsChoose['value'] == 'USDT' && coinBy['value'] == 'IR')
                {
                     a = amount * num
                     
                     a = parseInt(a)


                }else {
                    a = amount * num
                }
                
                setTargetPrice(num)
                setPriceAmount(a);
            }


        }

    }



    


    function separateNum(event) {
        let value = event.target.value
        var nStr = value + '';
        nStr = nStr.replace(/\,/g, "");
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        if (event !== undefined) {
            event.target.value = x1 + x2;
            ex_normalNum(event.target.value,event.target.name)
        } else {
            return x1 + x2;
        }
    }

    return(


        <>
        {witchItem == 'buy' ? 
        <>
        
        <div className={'row  mt-2'}>
        <div
            className="mb-1 col-12">
                <span
                    className={'text-medium lablett '}>قیمت مشخص ({coinBy.label} ) </span>
         
    
    
    
            <input name={'limit_price_amount'} id={'limit_price_amount'}
                className="myinput_form w-100 text-center border bg-custom-input input-order667 input-order667 iput2024" type={'tel'}
                placeholder={'قیمت مدنظر خود را وارد نمایید'} onKeyUp={separateNum}
            />

            <span className="text-war2023">
            در این حالت  قیمت ارز انتخابی، زیر «قیمت مشخص» بیاید ارز خریداری می شود.
            </span>
    
    
    
    
    
        </div>
    
    
    </div>
    <div className={'row '}>
        <div
            className="mb-1 col-12">
            <div>
                <span
                    className={'text-medium lablett '}>مقدار({coinsChoose.label} )</span>
    
    
            </div>
    
    
            <input name={'limit_amount'} id={'limit_amount'}
                className="myinput_form w-100 text-center border bg-custom-input input-order667 input-order667 iput2024" type={'tel'} placeholder="0"
                onKeyUp={separateNum}
    
            />
    
    
        </div>
    
    
    </div>
    
    
    <SliderVol handleChooseBalanceClick={handleChooseBalanceClick}/>
    
    
    
    
    
    <ul className="mb-2">
        <li className={'row text-medium mytext-warning mt-1'}>
    
            <div className={'col-6'}>
                <i className="fa fa-circle mytext-warning item_balance"></i>
                <span className={'text-medium mytext-warning'}>قیمت:</span>
            </div>
            <div className={'col-6 text_ml'}>
    
            {witchItem == 'buy' ? 
    
    (customCoin && customCoin['buyIrt'])?
    
    
    coinBy['value'] != 'IR'?
    
        (customCoin['sell']) >=1 ?
            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sell'])}</span>
            :
            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sell'])}</span>
    
    
            
    
    
    :
    
            (customCoin['buyIrt']) >=1 ?
            <span>{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buyIrt'])}</span>
            :
            <span>{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buyIrt'])}</span>
    
    
            
    
    
    
    :
    
    <i className="fa fa-spinner fa-spin"></i>
    
    
    :
    (customCoin && customCoin['sellIrt'])?
    
    
    coinBy['value'] != 'IR'?
    
        (customCoin['buy']) >=1 ?
            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buy'])}</span>
            :
            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'])}</span>
    
    
            
    
    
    :
    
            (customCoin['sellIrt']) >=1 ?
            <span>{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sellIrt'])}</span>
            :
            <span>{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sellIrt'])}</span>
    
    
            
    
    
    
    :
    
    <i className="fa fa-spinner fa-spin"></i>
    
    }
                <span className={'text-small'}>{coinBy.label} </span>
    
            </div>
    
    
        </li>
        <li className={'row text-medium mytext-warning mt-1'}>
    
            <div className={'col-6'}>
                <i className="fa fa-circle mytext-warning item_balance"></i>
                <span className={'text-medium mytext-warning'}>موجودی شما:</span>
            </div>
            <div className={'col-6 text_ml'}>
    
                {isAuth ?
                    <>
                        {coinBalance && processing ?
                            <span>{coinBalance['balance'] &&  new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(coinBalance['balance'])}</span>
                        :
                        <i className="fa fa-spinner fa-spin"></i>
    
                        }
                    <span className={'text-small'}>{coinBy.label}</span>
                    </>
    
                    :
    
                    <Link to={'/login'} className={'btn btn-primary btnsm text-small  '}>ورود| ثبت نام</Link>
    
    
                }
    
            </div>
    
    
        </li>
        <li className={'row text-medium mytext-warning mt-1'}>
    
            <div className={'col-6'}>
                <i className="fa fa-circle mytext-warning item_balance"></i>
                <span className={'text-medium mytext-warning'}> مبلغ خرید:</span>
            </div>
            <div className={'col-6 text_ml'}>
    
                                                                {coinsChoose.value=='USDT' && coinBy.value=='IR'?
                    <span>{priceAmount && new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount)}</span>
    
    
    
                :
    
                <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount-(priceAmount * KARMOZD))}</span>
            }
                <span className={'text-small'}>{coinBy.label} </span>
    
            </div>
    
    
        </li>
    
    
    
    
    
        <li className={'row text-medium mytext-warning mt-1'}>
    
            <div className={'col-6'}>
                <i className="fa fa-circle mytext-warning item_balance"></i>
                <span className={'text-medium mytext-warning'}> کارمزد:</span>
            </div>
            <div className={'col-6 text_ml'}>
    
            {coinsChoose.value=='USDT' && coinBy.value=='IR'?
    
                            <>
                            <span>0</span>
                            <span className={'text-small'}>{coinBy.label}</span>
    
    
    
                            </>
    
                            :
    
                            <>
                            {priceAmount>0 ? 
                            <>
                                <span className="text-line-th">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount * 0.002)}</span>
    
                                <span className="text-takhfif56">با تخفیف:</span>
                                <span className="color-off">0</span>
                                <span className={'text-small color-off'}>{coinBy.label}</span>
    
    
                            </>
    
                            :
    
                            <>
    
                            <span>0</span>
                            <span className={'text-small'}>{coinBy.label}</span>
                            </>
    
                            }
    
    
    
                            </>
        
    
                
    
            }
    
            </div>
    
    
        </li>
    
    
    
    
        <li className={'row text-medium mytext-warning mt-1'}>
    
            <div className={'col-6'}>
                <i className="fa fa-circle mytext-warning item_balance"></i>
                <span
                    className={'text-medium mytext-warning '}>  کل مبلغ خرید:</span>
            </div>
            <div className={'col-6 text_ml'}>
            {coinsChoose.value=='USDT' && coinBy.value=='IR'?
                <span className={'text-large mytext-warning'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount)}</span>
            
    
            :
    
    
                <span className={'text-large mytext-warning'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount)}</span>
            }
                <span className={'text-small'}>{coinBy.label} </span>
    
            </div>
    
    
        </li>
    
    
    
    </ul>

            {isAuth ?

                <div className={'row align-items-center mr-1 ml-1 pb-2'}>
                <button className={'btn btn-success py-2 px-2 btn-order-height'} name={'buy'} id={'buy'} onClick={handelSubmitBuy}>
                    {buttonClicked ? <i className="fa fa-spinner fa-spin loadIcon24 text-white"></i> :
                        <span>ثبت خرید</span>
                    }


                    </button>
                </div>
                                :
                <Link to={'/login'} className={'w-100'}>

                <div className={'row align-items-center mr-1 ml-1 pb-2'}>
                <button className={'btn btn-success py-2 px-2 btn-order-height'}>ورود برای خرید
                </button>


                </div>
                </Link>


            }
    
    </>

    :

    <>

        
                                <div className={'row  mt-2'}>
                                                <div
                                                    className="mb-1 col-12">
                                                    <span
                                                    className={'text-medium lablett '}>قیمت مشخص ({coinBy.label} ) </span>
                                            



                                            <input name={'price_limit_amount-sell'} id={'price_limit_amount-sell'}
                                                className="myinput_form w-100 text-center border bg-custom-input input-order667 input-order667 iput2024" type={'tel'}
                                                placeholder={'قیمت مدنظر خود را وارد نمایید'} onKeyUp={separateNum}
                                            />


<span className="text-war2023">
            در این حالت  قیمت ارز انتخابی، بالا «قیمت مشخص» بیاید ارز فروخته می شود.
            </span>


                                                </div>


                                            </div>
                                <div className={'row '}>
                                    <div
                                        className="mb-1 col-12">
                                        <div>
                                            <span
                                                className={'text-medium lablett '}>مقدار({coinsChoose.label}):</span>


                                        </div>


                                        <input name={'limit_amount_sell'} id={'limit_amount_sell'} value={sellAmountInput == 0 ? '' : sellAmountInput} onChange={(e)=>setSellAmountInput(e.target.value)} className="myinput_form w-100 text-center border bg-custom-input input-order667 iput2024 " type={'tel'} onKeyUp={separateNum}

                                                />


                                    </div>


                                </div>



                                <SliderVol handleChooseBalanceClick={handleChooseBalanceClick}/>



                                <ul className={'mb-2'}>
                                    <li className={'row text-medium mytext-warning mt-1'}>

                                        <div className={'col-6'}>
                                            <i className="fa fa-circle mytext-warning item_balance"></i>
                                            <span className={'text-medium mytext-warning'}>قیمت:</span>
                                        </div>
                                        <div className={'col-6 text_ml'}>

                                            {

(customCoin && customCoin['sellIrt'])?
    
    
coinBy['value'] != 'IR'?

    (customCoin['buy']) >=1 ?
        <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['buy'])}</span>
        :
        <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['buy'])}</span>


        


:

        (customCoin['sellIrt']) >=1 ?
        <span>{ new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(customCoin['sellIrt'])}</span>
        :
        <span>{ new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(customCoin['sellIrt'])}</span>


        



:

<i className="fa fa-spinner fa-spin"></i>




                                            }

                       


                                        </div>


                                    </li>
                                    <li className={'row text-medium mytext-warning mt-1'}>

                                        <div className={'col-6'}>
                                            <i className="fa fa-circle mytext-warning item_balance"></i>
                                            <span className={'text-medium  mytext-warning'}>موجودی شما:</span>
                                        </div>
                                        <div className={'col-6 text_ml'}>

                                            {isAuth ?
                                                <>
                                            {coinBalance && processing ?
                                                <span>{coinBalance['balance'] && new Intl.NumberFormat("fa",{maximumFractionDigits:baseCoinIncrement}).format(coinBalance['balance'])}</span>
                                                    :
                                                        <i className="fa fa-spinner fa-spin"></i>

                                                    }
                                                    <span className={'text-small'}>{coinsChoose.label} </span>
                                                </>

                                                :

                                                <Link to={'/login'} className={'btn btn-primary btnsm text-small  '}>ورود| ثبت نام</Link>


                                            }

                                        </div>


                                    </li>
                                    <li className={'row text-medium mytext-warning mt-1'}>

                                        <div className={'col-6 '}>
                                            <i className="fa fa-circle mytext-warning item_balance"></i>
                                            <span
                                                className={'text-medium mytext-warning'}> مبلغ دریافتی:</span>
                                        </div>
                                        <div className={'col-6 text_ml'}>
                                        {coinsChoose.value=='USDT' && coinBy.value=='IR'?

                                            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount)}</span>
                                            :

                                            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount - priceAmount*KARMOZD)}</span>
                                        }
                                            <span className={'text-small'}>{coinBy.label}</span>

                                        </div>


                                    </li>


                                


                                    <li className={'row text-medium mytext-warning mt-1'}>

                                        <div className={'col-6 '}>
                                            <i className="fa fa-circle mytext-warning item_balance"></i>
                                            <span className={'text-medium mytext-warning'}> کارمزد:</span>
                                        </div>
                                        <div className={'col-6 text_ml'}>
                                                                                            {coinsChoose.value=='USDT' && coinBy.value=='IR'?
                                            <>
                                            <span>0</span>
                                            <span className={'text-small'}>{coinBy.label}</span>


                                            
                                            </>

                                            :

                                            <>
                                            {priceAmount > 0 ? 
                                            <>
                                                <span className="text-line-th">{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount * 0.002)}</span>

                                                <span className="text-takhfif56">با تخفیف:</span>
                                                <span className="color-off">0</span>
                                                <span className={'text-small color-off'}>{coinBy.label}</span>


                                                </>

                                            :

                                            <>

                                            <span>0</span>
                                            <span className={'text-small'}>{coinBy.label}</span>
                                            </>

                                            }


                                            
                                            </>


                                }

                                        </div>


                                    </li>


                                    

                                    <li className={'row text-medium mytext-warning mt-1'}>

                                        <div className={'col-6'}>
                                            <i className="fa fa-circle mytext-warning item_balance"></i>
                                            <span
                                                className={'text-medium mytext-warning'}> مبلغ خالص دریافتی:</span>
                                        </div>
                                        <div className={'col-6 text_ml'}>
                                                                                            {coinsChoose.value=='USDT' && coinBy.value=='IR'?

                                            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount)}</span>
                                            :       


                                            <span>{new Intl.NumberFormat("fa",{maximumFractionDigits:quoteCoinIncrement}).format(priceAmount - (priceAmount*KARMOZD))}</span>
                                            }
                                            <span className={'text-small'}>{coinBy.label}</span>

                                        </div>


                                    </li>


                                </ul>

                                            <div className={'align-items-center  div_nokte'}>
                                                <div className={'align-items-center'}>
                                            <span className={'text-small text-price'}>

                                        </span>
                                                </div>

                                            </div>


                                            {isAuth ?

                                                <div className={'row align-items-center mr-1 ml-1 pt-1 '}>
                                                        <button id="sell" className={'btn btn-danger py-2 px-2 btn-order-height'} name={'sell'} onClick={handelSubmitSell}>
                                                        {buttonClicked ? <i className="fa fa-spinner fa-spin loadIcon24"></i> :
                                                            <span>ثبت فروش</span>
                                                        }
                                                    </button>
                                                </div>

                                                :

                                                <Link to={'/login'}>
                                                    <div className={'row align-items-center mr-1 ml-1 pt-1 '}>
                                                        <button className={'btn btn-danger py-2 px-2 btn-order-height'}>ورود برای فروش
                                                        </button>
                                                    </div>

                                                </Link>

                                            }
    
    </>

        }

    

    </>




    )
}